<template>
    <div class="modal fade" tabindex="-1" :id="id">
        <div class="modal-dialog modal-lg">
          <form id="kt_modal_form_project" @submit.prevent="addTask" class="form mt-5" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('tasks.add') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor"/>
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor"/>
                    </svg>
                  </span>
                </div>
              </div>
              <TaskForm 
                :id="id"
              
                v-model="formData" 
                :contacts="contacts" 
                :milestones="milestones"
                :priorities="priorities"
                :users="users"
                :min="formatDate(currentProject?.start_date)"
                :max="formatDate(currentProject?.end_date)"
                />   
              <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <PriorityModal id="create-priority-modal" :parent="id" @load="loadTaskPriorities"/>

</template>

<script setup>

import { defineProps,inject,ref, watch } from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import { computed } from 'vue';
import TaskForm from './TaskForm.vue';
import { useRoute } from 'vue-router';
import PriorityModal from '../PriorityModal.vue';
import { format } from 'date-fns';


const props = defineProps({
    id:{type: String, default:"create_project_modal"},
    form:{
        type:Object,
        default:{
          title: "",
          project_id: "",
          project_category_step_id: "",
          task_status_id: "",
          task_priority_id: "",
          description: "",
          start_date: "",
          end_date: "",
          delay_value: 0,
          delay_unit: "",
          users: [],
          need_review: false
        }
    }
})


const store = useStore()
const route = useRoute()

const formData = ref({}) 

watch(() => props.form, (value) => {
    formData.value = {...value}
}, { deep: true })


const currentProject = computed(() => store.getters['projects/getCurrentProject'])
const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])
const contacts = computed(() => store.getters['contacts/getContacts'])

const milestones = computed(() => store.getters['projectSteps/getProjectSteps'])
const priorities = computed(() => store.getters['taskPriorities/getTaskPriorities'])

const allUsers = computed(() => store.getters["user/getUsers"])


const users = computed(() => {
  if(currentProject.value && currentProject.value.users && currentProject.value.users.length ){
    let users = [...currentProject.value.users]
    currentProject.value.managers.forEach((manager) => {
      if(!users.find(user => user.id === manager.id)) {
        users.push(manager)
      }
    })
    return users
  }
  return allUsers.value
})

const isLoading = ref(false)

const emit = defineEmits(['reloadDatatable', 'reloadData'])

function formatDate(date){
  return date && format(date, "dd-MM-yyyy HH:mm")
}
function loadTaskPriorities(id){
  formData.value = { ...formData.value, task_priority_id: id };
}

function closeModal(){
  $('#'+props.id).modal('toggle')
}

async function addTask() {
    isLoading.value = true
    try{

      await store.dispatch('tasks/createTask', {...formData.value, project_id: route.params.id}).then(() => {
        window.toastr.success(i18n.global.t("notification.tast_created"))
        emit('reloadData')
        formData.value={
          title: "",
          project_id: "",
          project_category_step_id: "",
          task_status_id: "",
          task_priority_id: "",
          description: "",
          start_date: "",
          end_date: "",
          users: [],
          need_review: false
        }
        isLoading.value = false
        closeModal()
      }).finally(() => {
      }) 

     
    }catch(err){
      isLoading.value = false
    }
}
</script>
